import "./index.scss";
import React, { useState } from "react";

interface ICollapsiblePanel {
  title: string;
  children: React.ReactNode;
  openByDefault?: boolean;
  titleRender?: () => React.ReactNode;
  style?: object;
}

const CollapsiblePanel: React.FC<ICollapsiblePanel> = ({
  title,
  children,
  openByDefault: expantByDefault = false,
  titleRender = null,
  style = {},
}) => {
  const [open, setOpen] = useState(expantByDefault);

  return (
    <div className={"sys-mdae-collapsible-panel"} style={style}>
      <div
        className="sys-mdae-collapsible-panel-header"
        onClick={() => setOpen(!open)}
      >
        <div>{typeof titleRender === "function" ? titleRender() : title}</div>

        {/* Font Awesome chevron */}
        <i className={`fa fa-angle-down case-arrow ${open ? "open" : ""}`} />
      </div>

      <div className={`case-content ${open ? "show" : ""}`}>{children}</div>
    </div>
  );
};

export default CollapsiblePanel;
